module.exports = __webpack_public_path__ + "static/media/c++.d44015ef.png";